import { FC } from "react";
import { useTranslation } from "react-i18next";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import ManagementCard from "./ManagementCard";
import { managementServiceFactory } from "../../../services/ManagementServiceImpl";
import { IManagement, ManagementFiltersValues } from "../../../domain/models/Management";
import { managementFiltersFields, managementFiltersSchemaFactory } from "../../../validation-schemas/ManagementSchemas";
import ManagementEditor from "./ManagementEditor";

const managementService = managementServiceFactory();
const ManagementPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<IManagement, ManagementFiltersValues>
            filtersFieldsMeta={managementFiltersFields}
            filtersSchema={managementFiltersSchemaFactory(t)}
            service={managementService}
            renderItem={(item, onEdit, onDelete) => (
                <ManagementCard item={item} onEdit={onEdit} onDelete={onDelete} onClick={() => 1} />
            )}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <ManagementEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default ManagementPage;
